module.exports = __webpack_public_path__ + "img/reitou_syokuhin.74d1e2e8.png";